export type SearchMenuTitle = 'Destinations' | 'Dates' | 'Themes' | 'Preferences';

export interface SearchMenu {
  title: SearchMenuTitle;
  defaultIcon: { src: string; alt: string };
  disabledIcon: { src: string; alt: string };
  whiteIcon: { src: string; alt: string };
  defaultTagImgPath?: string;
}

// タグ画像は Cloudflare Image Resizing を経由するため、変換元は allowed origins に登録済みの
// ストレージドメインである必要がある（firebasestorage.googleapis.com は未登録のため 403 err=9401 になる）。
// オリジンは環境変数 STORAGE_BASE_URL（runtimeConfig.public）から注入する。
export const searchMenu = (storageBaseUrl: string): SearchMenu[] => {
  return [
    {
      title: 'Destinations',
      defaultIcon: { src: 'location/default.svg', alt: 'Search by destinations' },
      disabledIcon: { src: 'location/gray.svg', alt: 'Search by destinations' },
      whiteIcon: { src: 'location/white.svg', alt: 'Search by destinations' },
      defaultTagImgPath: `${storageBaseUrl}/images%2Fmap-default.svg?alt=media`,
    },
    {
      title: 'Dates',
      defaultIcon: { src: 'calendar/default.svg', alt: 'Search by dates' },
      disabledIcon: { src: 'calendar/gray.svg', alt: 'Search by dates' },
      whiteIcon: { src: 'calendar/white.svg', alt: 'Search by dates' },
    },
    {
      title: 'Themes',
      defaultIcon: { src: 'hashtag/default.svg', alt: 'Search by themes' },
      disabledIcon: { src: 'hashtag/gray.svg', alt: 'Search by themes' },
      whiteIcon: { src: 'hashtag/white.svg', alt: 'Search by themes' },
    },
    {
      title: 'Preferences',
      defaultIcon: { src: 'interest/default.svg', alt: 'Search by preferences' },
      disabledIcon: { src: 'interest/gray.svg', alt: 'Search by preferences' },
      whiteIcon: { src: 'interest/white.svg', alt: 'Search by preferences' },
    },
  ];
};
